module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"seeAll":"See all credit card results"}}')
  delete Component.options._Ctor
}
